// src/components/checkout/addressList.js

import React from 'react';

const AddressList = ({ addresses, selectedAddress, onSelect }) => {
  if (!addresses || addresses.length === 0) {
    return (
      <div className="bg-yellow-50 p-4 rounded-md text-center">
        <p className="text-yellow-800">You don't have any saved addresses.</p>
        <p className="text-sm mt-2">Please add a new address to continue.</p>
      </div>
    );
  }
  
  return (
    <div className="space-y-4">
      {addresses.map(address => (
        <div
          key={address.addressId}
          className={`border rounded-md p-4 cursor-pointer ${
            selectedAddress === address.addressId ? 'border-blue-500 bg-blue-50' : 'hover:border-gray-400'
          }`}
          onClick={() => onSelect(address.addressId, address)}
        >
          <div className="flex justify-between items-start">
            <div>
              <div className="font-medium">{address.fullName}</div>
              <div className="text-sm text-gray-600 mt-1">
                {address.addressLine1}
                {address.addressLine2 && `, ${address.addressLine2}`}
                {address.landmark && `, ${address.landmark}`}
              </div>
              <div className="text-sm text-gray-600">
                {address.city}, {address.state} - {address.pincode}
              </div>
              <div className="text-sm text-gray-600 mt-1">
                Phone: {address.phone}
              </div>
            </div>
            
            <div className="flex flex-col items-end">
              <span className="inline-block px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded-full">
                {address.addressType}
              </span>
              
              {address.isDefault && (
                <span className="inline-block mt-2 px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">
                  Default
                </span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AddressList;